import React, { useEffect, useState } from "react";
// import logo from "../assets/images/DB collection logo.svg";
import Spendbox from "../../assets/images/spendbox.svg";
import Heart from "../../assets/images/Heart.svg";
import BrokenHeart from "../../assets/images/Broken Heart.svg";
import { Link } from "react-router-dom";
import Logo from "../../components/atoms/logo";
import axios from "axios";
import { API_URL } from "../../constants";
import { Container, HeaderContainer, SubContainer, Left, Right, Content, SubHeading, MyBusiness, BusinessList, Remove, Add, Empty, BusinessSuggestionList, List, Text, Suggestion, SuggestionHeading } from "./styles";
export default function Explore() {
  const [businesses, setBusinesses] = useState([]);
  const [isAll, setAll] = useState(false);
  const [fetch, setFetch] = useState(false);
  const [suggetion, setSuggestion] = useState<string>();
  const [savedBusinesses, setSavedBusinesses] = useState<any>([]);
  let dataToStore: any = {
    business: {},
  };

  let existingBusiness: any;
  let dataArray: any;

  // get saved data
  const getSavedData = async () => {
    existingBusiness = await localStorage.getItem("savedBusinesses");
    dataArray = JSON.parse(existingBusiness) || [];
    setSavedBusinesses(dataArray);
  };

  // data to store
  const addDataToStore = (data: any) => {
    existingBusiness = localStorage.getItem("savedBusinesses");
    dataArray = JSON.parse(existingBusiness) || [];

    // check if data already exist
    if (dataArray.some((item: any) => item.id === data.id)) {
      console.log("data already exist");
      return;
    }
    dataToStore = {
      id: data.id,
      businessUuid: data.businessUuid,
    };

    // add data to local storage
    dataArray.unshift(dataToStore);
    const jsonString = JSON.stringify(dataArray);
    // save data to local storage
    localStorage.setItem("savedBusinesses", jsonString);
    setFetch(!fetch);
  };

  // data to delete
  const DataToDelete = (data: any) => {
    existingBusiness = localStorage.getItem("savedBusinesses");
    dataArray = JSON.parse(existingBusiness) || [];

    // filter data to delete
    const updatedArray = dataArray.filter((item: any) => item.id !== data.id);
    const jsonString = JSON.stringify(updatedArray);
    // save data to local storage
    localStorage.setItem("savedBusinesses", jsonString);
    setFetch(!fetch);
  };

  // get businesses
  const getBusinesses = async () => {
    axios
      .get(`${API_URL}/businesses`)
      .then((response) => {
        if (response.status === 200) {
          const businesses = response.data.data;
          setBusinesses(businesses);
        }
      })
      .catch((error) => {
        // console.log(error)
        // toast.error("Connection Failed");
      });
  };

  // map gotten businesses
  const mappedBussiness = savedBusinesses?.map((business: any) => {
    return business.businessUuid;
  });
  // filter gotten businesses
  // const filteredBusinesses = businesses?.filter((business: any) => {
  //   return !mappedBussiness.includes(business.businessUuid);
  // });

  // filter saved businesses
  let filterSavedBusiness = businesses?.filter((business: any) => {
    return mappedBussiness.includes(business.businessUuid);
  });

  // get suggestion
  const suggest = async () => {
    const getSuggest: any = await localStorage.getItem("suggest");
    // const suggest = JSON.parse(jsonString)

    setSuggestion(getSuggest);
  };
  let suggestedBusiness = businesses.filter(
    (o: any) => o.businessUuid === suggetion
  );

  useEffect(
    () => {
      getBusinesses();
      getSavedData();
      suggest();
    },
    // eslint-disable-next-line
    [fetch]
  );

  return (
    <Container>
      <HeaderContainer>
        <div>
          <Link to="/">
            <Logo src={Spendbox} />
          </Link>
        </div>
      </HeaderContainer>

      <SubContainer>
        <Left>
          <p className=" text-[#bbb]">Welcome to your Explore Page</p>
        </Left>
        <Right>
          <Content>
            <SubHeading>
              <h1
                onClick={() => {
                  setAll(false);
                }}
                className={isAll ? "" : "text-black"}
              >
                My Businesses ({filterSavedBusiness.length}/{businesses.length})
              </h1>
              <p
                onClick={() => {
                  setAll(true);
                }}
                className={isAll ? "text-black" : ""}
              >
                All
              </p>
            </SubHeading>

            {isAll ? (
              <>
                {" "}
                {businesses.length !== 0 ? (
                  businesses.map((business: any) => (
                    <MyBusiness key={business.businessUuid}>
                      <BusinessList>
                        <Link to={`/${business.slug}`} className="link">
                          <img src={business.image} alt="" />
                          <div>
                            <p>{business.name}</p>
                          </div>
                        </Link>
                      </BusinessList>
                      {mappedBussiness.includes(business.businessUuid) ? (
                        <Remove
                          onClick={() => {
                            DataToDelete(business);
                          }}
                        >
                          <p>Remove</p>
                          <img src={BrokenHeart} alt="" />
                        </Remove>
                      ) : (
                        <Add
                          onClick={() => {
                            addDataToStore(business);
                          }}
                        >
                          <p>Add</p>
                          <img src={Heart} alt="business" />
                        </Add>
                      )}
                    </MyBusiness>
                  ))
                ) : (
                  <Empty>
                    <p>You have not added anything to your favorites</p>
                  </Empty>
                )}
              </>
            ) : (
              <>
                {filterSavedBusiness.length !== 0 ? (
                  filterSavedBusiness.map((business: any) => (
                    <MyBusiness key={business.businessUuid}>
                      <BusinessSuggestionList>
                        <Link to={`/${business.slug}`} className="link">
                          <List>
                            <img src={business.image} alt="" />
                            <Text>
                              <p>{business.name}</p>
                            </Text>
                            <p>1% Discount</p>
                          </List>
                        </Link>
                      </BusinessSuggestionList>
                    </MyBusiness>
                  ))
                ) : (
                  <Empty>
                    <p>You have not added anything to your favorites</p>
                  </Empty>
                )}
              </>
            )}
          </Content>
        </Right>
      </SubContainer>

      <Suggestion>
        <SuggestionHeading>Suggestion</SuggestionHeading>
        {businesses &&
          suggestedBusiness.map((business: any) => (
            <BusinessSuggestionList key={business.businesUuid}>
              <Link to={`/${business.slug}`} className="link">
                <List>
                  <img src={business.image} alt="" />
                  <Text>
                    <p>{business.name}</p>
                  </Text>
                </List>
              </Link>
              <Add
                onClick={() => {
                  addDataToStore(business);
                }}
              >
                <p>Add</p>
                <img src={Heart} alt="business" />
              </Add>
            </BusinessSuggestionList>
          ))}
      </Suggestion>
    </Container>
  );
}
